import { Action } from 'redux';

export const IS_OPEN_MODAL_NAME = 'layout/IS_OPEN_MODAL_NAME';
export const isOpenModalName = (data: string | undefined) => {
  return {
    type: IS_OPEN_MODAL_NAME,
    payload: data,
  };
};
export const SHOW_CUSTOM_RANGE_MODAL = 'layout/SHOW_CUSTOM_RANGE_MODAL';
export const showCustomRangeModal = () => ({
  type: SHOW_CUSTOM_RANGE_MODAL,
});

export const HIDE_CUSTOM_RANGE_MODAL = 'layout/HIDE_CUSTOM_RANGE_MODAL';
export const hideCustomRangeModal = () => ({
  type: HIDE_CUSTOM_RANGE_MODAL,
});

export const HIDE_BULK_PROCESS_CITATION = 'layout/HIDE_BULK_PROCESS_CITATION';
export const hideBulkManageCitation = () => ({
  type: HIDE_BULK_PROCESS_CITATION,
});
export const SHOW_BULK_PROCESS_CITATION = 'layout/SHOW_BULK_PROCESS_CITATION';
export const showBulkManageCitation = () => ({
  type: SHOW_BULK_PROCESS_CITATION,
});

export interface ShowBulkCitationAction extends Action<typeof SHOW_BULK_PROCESS_CITATION> {}
export interface HideBulkCitationAction extends Action<typeof HIDE_BULK_PROCESS_CITATION> {}

// show export batch process

export const HIDE_BULK_EXPORT_CITATION = 'layout/HIDE_BULK_EXPORT_CITATION';
export const hideBulkExportCitation = () => ({
  type: HIDE_BULK_EXPORT_CITATION,
});
export const SHOW_BULK_EXPORT_CITATION = 'layout/SHOW_BULK_EXPORT_CITATION';
export const showBulkExportCitation = () => ({
  type: SHOW_BULK_EXPORT_CITATION,
});

export interface ShowBulkExportCitationAction extends Action<typeof SHOW_BULK_EXPORT_CITATION> {}
export interface HideBulkExportCitationAction extends Action<typeof HIDE_BULK_EXPORT_CITATION> {}
// show export batch process end

export interface IsOpenModalNameAction extends Action<typeof IS_OPEN_MODAL_NAME> {
  readonly payload: string | undefined;
}

export interface ShowCustomRangeModalAction extends Action<typeof SHOW_CUSTOM_RANGE_MODAL> {}
export interface HideCustomRangeModalAction extends Action<typeof HIDE_CUSTOM_RANGE_MODAL> {}

export type LayoutAction =
  | IsOpenModalNameAction
  | ShowCustomRangeModalAction
  | HideCustomRangeModalAction
  | ShowBulkCitationAction
  | ShowBulkExportCitationAction
  | HideBulkExportCitationAction
  | HideBulkCitationAction;
